import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import { Trans, useTranslation } from 'react-i18next';
import { usePaymentSecurityContext } from '../../../context';
import PaymentSecurityLink from '../link';
import DebtCancellationTextContainer from './subcomponents';
const PaymentSecurityDebtCancellation = ({ hideBottomSpace, className }) => {
    const { t } = useTranslation();
    const { config } = usePaymentSecurityContext();
    const { assets } = config.hosts;
    const cancellationAgreementText = t('common.cancellationAgreementText');
    return (_jsxs("div", { className: className, children: [_jsx(DebtCancellationTextContainer, { children: _jsx(Trans, { i18nKey: "common.paymentSecurityCancellationAgreement", values: {
                        cancellationAgreementText
                    }, components: {
                        cancellationAgreementLink: (_jsx(PaymentSecurityLink, { href: `${assets}assets/account-services/payment_security_debt_cancellation_program_agreement.pdf`, children: cancellationAgreementText }))
                    } }) }), !hideBottomSpace && _jsx(Stack, { size: "large" })] }));
};
export default PaymentSecurityDebtCancellation;
